// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-slider-process{background-color:#1c1a17!important}.vue-slider-rail{background-color:#ddd!important}.vue-slider-dot{border-radius:50%!important;border:1px solid #ddd!important;background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
